module.exports = __webpack_public_path__ + "static/media/thumb.ef17fa52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/alabama-rural-studio/thumb.jpg
// module id = 39
// module chunks = 0